export default function({ $auth, error }) {
  if (!$auth.user?.roles?.includes('admin'))
    return error({
      statusCode: 403,
    })
}
